module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/personality-relax-riben.bf35eedb.png";